import type { ReactNode } from 'react'
import { ChatCircleDots, DeviceMobile, Phone } from '@phosphor-icons/react'
import ImeiHubSignalIcon from './ImeiHubSignalIcon'

export type SellPathCardIconKind =
  | 'with-imei'
  | 'without-imei'
  | 'smartphone'
  | 'basic-phone'
  | 'promo-quick-sell'
  | 'promo-feedback'

const HUB_ICON_SIZE = 22
const HUB_ICON_WEIGHT = 'regular' as const

type Props = {
  kind: SellPathCardIconKind
}

function SellPathPhosphorIcon({ children }: { children: ReactNode }) {
  return (
    <span className="vc-imei-hub__signal" aria-hidden="true">
      {children}
    </span>
  )
}

/** Sell path card icons — same container as IMEI hub service cards. */
export default function SellPathCardIcon({ kind }: Props) {
  if (kind === 'with-imei') {
    return <ImeiHubSignalIcon service="passport" />
  }

  if (kind === 'smartphone' || kind === 'without-imei') {
    return (
      <SellPathPhosphorIcon>
        <DeviceMobile size={HUB_ICON_SIZE} weight={HUB_ICON_WEIGHT} />
      </SellPathPhosphorIcon>
    )
  }

  if (kind === 'basic-phone') {
    return (
      <SellPathPhosphorIcon>
        <Phone size={HUB_ICON_SIZE} weight={HUB_ICON_WEIGHT} />
      </SellPathPhosphorIcon>
    )
  }

  if (kind === 'promo-feedback') {
    return (
      <SellPathPhosphorIcon>
        <ChatCircleDots size={HUB_ICON_SIZE} weight={HUB_ICON_WEIGHT} />
      </SellPathPhosphorIcon>
    )
  }

  return (
    <SellPathPhosphorIcon>
      <DeviceMobile size={HUB_ICON_SIZE} weight={HUB_ICON_WEIGHT} />
    </SellPathPhosphorIcon>
  )
}
